module.exports = __webpack_public_path__ + "img/envmap.4a3d4f25.png";